<template>
  <div class="reports">
    <ReportWinloseComponent
      :ref-key-text="refKeyText"
      :title="title"
      :url-path="urlPath"
      :route-name="routeName"
      :is-simple="false"
    />
  </div>
</template>

<script>
import ReportWinloseComponent from '@/components/ReportWinloseComponent.vue'

export default {
  components: {
    ReportWinloseComponent,
  },
  data() {
    return {
      refKeyText: 'Username',
      title: 'W/L Member (Detail)',
      urlPath: '/reports/member_winlose_detail',
      routeName: 'reports-member-winlose-detail',
    }
  },
}
</script>

<style>

</style>
